@if (state === serviceStateEnum.ERROR || state === serviceStateEnum.INFO) {
  <mwe-alert
    [type]="state === serviceStateEnum.INFO ? 'info' : 'danger'"
    [titleKey]="errorTitleKey"
    [messageKey]="errorMsgKey"
    [placeholderMap]="alertPlaceholders"
  />
}
<div class="sr-only" aria-live="assertive">
  @if (state === serviceStateEnum.LOADING) {
    <ng-container [translate]="workInProgressMsgKey" />
  }
  @if (state === serviceStateEnum.SUCCESS) {
    <ng-container [translate]="successMsgKey" />
  }
</div>
<mwe-basic-card aria-live="polite">
  @if (state === serviceStateEnum.LOADING) {
    <div>
      <h1 data-test="mwe-confirmation-view-header-loading" class="h6 text-center" [translate]="workInProgressMsgKey"></h1>
      <br />
      <dotlottie-player
        class="mx-auto mb-5 d-block"
        aria-hidden="true"
        autoplay
        loop
        playMode="normal"
        id="dot-lottie-confirmation-loading"
        src="/assets/loading-animation/windmills.lottie"
        playerId="dot-lottie-confirmation-loading"
        style="max-width: 214px"
      />
    </div>
  }
  @if (state === serviceStateEnum.SUCCESS) {
    <div>
      @if (!!successMsgKey) {
        <h1
          data-test="mwe-confirmation-view-header-success"
          class="h6 text-center"
          [translate]="successMsgKey"
          [translateParams]="generalTranslateValues"
        ></h1>
      }
      @if (isSuccessImageVisible) {
        <div class="row mb-4">
          <div class="col my-auto text-center">
            @if (!useStaticSuccessImage) {
              <img [src]="successImageSrc" alt="" class="animation img-fluid" alt="" />
            }
            @if (useStaticSuccessImage) {
              <img src="/assets/img/success.png" alt="" style="height: 200px" class="mt-3" />
            }
          </div>
        </div>
      }
      @if (!!bottomMsgKey) {
        <h1
          data-test="mwe-confirmation-view-header-success"
          class="h6 text-center"
          [translate]="bottomMsgKey"
          [translateParams]="generalTranslateValues"
        ></h1>
      }
    </div>
  }
  <div class="steps is-vertical" role="list">
    @for (bulletId of bulletIds; track bulletId; let last = $last) {
      <mwe-bullet
        [bulletId]="bulletId"
        [bulletLabelMap]="bulletLabelMap"
        [bulletStateMap]="bulletStateMap"
        [bulletTitleMap]="bulletTitleMap"
        [bulletTranslateMap]="bulletTranslateMap"
        [bulletStateClassMap]="bulletStateClassMap"
        [bulletStateIconMap]="bulletStateIconMap"
        [hasVerticalLine]="forcedLastLine || !last"
      />
    }
    <ng-content />
  </div>
</mwe-basic-card>
